// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2ed-K","inner":"Form_inner__3CqLD","range":"Form_range__XW5sT","name":"Form_name__GW5OY","actions":"Form_actions__Ta3ZC"};